import React from "react";
import { Routes, Route } from "react-router-dom";

// Import the ThemeProvider
// Note: Settings from this file is aliased as NewSettings to distinguish from ./components/Settings
// import { ThemeProvider, Settings as NewSettings } from "./pages/Settings";

// Public Pages
import LandingPage from "./pages/LandingPage";
import Login, { ResetPasswordPage } from './pages/Login';
import Register from "./pages/Register";
import SetPassword from './pages/SetPassword';

// All other pages and components (Existing Employee Imports)
import MainLayout from "./components/MainLayout";
import Dashboard from "./pages/Dashboard";
import Employees from "./pages/Employees";
import Leaves from "./pages/Leaves";
import MISDashboard from "./components/MISChart";
import Payroll from "./pages/Payroll";
import CVBank from "./pages/CVBank";
import Settings from "./components/Settings";
import LeaveBalance from "./pages/LeaveBalance";
import Salary from "./pages/Salary";
import Bonus from "./pages/Bonus";
import JobOffer from "./pages/JobOffer";
import PerformanceDashboard from "./pages/PerformanceDashboard";
import PerformanceReview from "./pages/PerformanceReview";
import GoalsTracking from "./pages/GoalsTracking";
import Feedback360 from "./pages/Feedback360";
import EmployeeProfile from "./pages/EmployeeProfile";
import TrainingDashboard from "./pages/TrainingDashboard";
import CourseDetails from "./pages/CourseDetails";
import OrganizationStructure from "./pages/OrganizationStructure";
import AttendanceSelfie from "./pages/AttendanceSelfie";
import AttendanceGeofence from "./pages/AttendanceGeofence";
import RotationalShift from "./pages/RotationalShift";
import FieldWorkReport from "./pages/FieldWorkReport";
import EmployeeLiveTracking from "./pages/EmployeeLiveTracking";
import ContinuousLocationPunching from "./pages/ContinuousLocationPunching";
import TrainingCalendar from "./pages/TrainingCalendar";
import JobOfferManagement from "./pages/JobOfferManagement";
import Announcements from "./pages/Announcements";
import PFESIReport from "./pages/PFESIReport";
import GrowthPerformanceReport from "./pages/GrowthPerformanceReport";
import JobWorkReport from "./pages/JobWorkReport";
import EmployeeESS from "./pages/EmployeeESS";
import ExpenseReimbursement from "./pages/ExpenseReimbursement";
import AnalyticsDashboard from "./pages/AnalyticsDashboard";
import LMSDashboard from "./pages/LMSDashboard";
import SkillMatrix from "./pages/SkillMatrix";
import RecruitmentDashboard from "./pages/RecruitmentDashboard";
import OnboardingAutomation from "./pages/OnboardingAutomation";
import Onboarding from "./pages/Onboarding";
import Exit from "./pages/Exit";

// Employer-specific pages
import EmployerDashboard from "./pages/EmployerDashboard";
import EmployerLayout from "./components/EmployerLayout";
import RecruitmentPipeline from "./pages/RecruitmentPipeline";
import OnboardingOffboarding from "./pages/OnboardingOffboarding";
import TrainingDevelopment from "./pages/TrainingDevelopment";
import InternalCommunications from "./pages/InternalCommunications";
import LeaveManagement from "./pages/LeaveManagement";
import TeamOverview from "./pages/TeamOverview";
import EmployeeManagement from "./pages/EmployeeManagement";
import AttendanceReports from "./pages/AttendanceReports";
import PayrollOverview from "./pages/PayrollOverview";
import PerformanceReports from "./pages/PerformanceReports";
import GoalsObjectives from "./pages/GoalsObjectives";

// NEW IMPORTS
import FeedbackManagement from "./pages/FeedbackManagement";
import TrainingAssignments from "./pages/TrainingAssignments";

// EMPLOYEE SELF-SERVICE (ESS) IMPORTS
import PayslipHistory from "./pages/PayslipHistory";
import MyBenefits from "./pages/MyBenefits";
import CompanyDirectory from "./pages/CompanyDirectory";
import LeaveRequests from "./pages/LeaveRequests";
import EmployeeDocuments from "./pages/EmployeeDocuments";
import Helpdesk from "./pages/Helpdesk";
import InternalJobs from "./pages/InternalJobs";
import Engagement from "./pages/Engagement";

// STRATEGIC EMPLOYER DASHBOARD IMPORTS
import FinanceDashboard from "./pages/FinanceDashboard";
import RecruitmentAnalytics from "./pages/RecruitmentAnalytics";
import WorkforceTurnover from "./pages/WorkforceTurnover";
import ComplianceAudit from "./pages/ComplianceAudit";
import AssetManagement from "./pages/AssetManagement";
import SkillGapAnalysis from "./pages/SkillGapAnalysis";
import TalentManagement from "./pages/TalentManagement";
import EngagementReports from "./pages/EngagementReports";
import DocumentRepository from "./pages/DocumentRepository";
import TeamRequests from "./pages/manager/requests/TeamRequests.jsx";
import TeamAttendanceReports from "./pages/manager/attendance/TeamAttendanceReports.jsx";

// ADMIN DASHBOARD IMPORTS
import AdminLayout from "./components/AdminLayout";
import AdminDashboard from "./pages/AdminDashboard";
import AdminProfile from "./pages/AdminProfile";
import AuditLogs from "./pages/AuditLogs";
import AlertsNotifications from "./pages/AlertsNotifications";
import ScheduledJobs from "./pages/ScheduledJobs";
import MasterDataManagement from "./pages/MasterDataManagement";
import AssetInventory from "./pages/AssetInventory";
import ReportsDashboard from "./pages/ReportsDashboard";
import WorkflowApproval from "./pages/WorkflowApproval";
import PolicyManagement from "./pages/PolicyManagement";
import BillingLicensing from "./pages/BillingLicensing";
import SystemSettings from "./pages/SystemSettings";
import CustomReportBuilder from "./pages/CustomReportBuilder";
import UserManagement from "./pages/UserManagement";
import HelpdeskSupport from "./pages/HelpdeskSupport";
import CustomBranding from "./pages/CustomBranding";
import APIDocumentation from "./pages/APIDocumentation";
import AccessControlLogs from "./pages/AccessControlLogs";
import AuthSecuritySettings from "./pages/AuthSecuritySettings";
import EncryptionKeyMgmt from "./pages/EncryptionKeyMgmt";
import ScheduledMaintenance from "./pages/ScheduledMaintenance";
import BackupRecoveryControl from "./pages/BackupRecoveryControl";
import ResourceQuotas from "./pages/ResourceQuotas";
import DataPrivacyCompliance from "./pages/DataPrivacyCompliance";
import SystemHealthMonitoring from "./pages/SystemHealthMonitoring";
import AutomatedAlertsTriggers from "./pages/AutomatedAlertsTriggers";
import ReleaseFeatureLogs from "./pages/ReleaseFeatureLogs";
import WebhookTests from "./pages/WebhookTests";
import ErrorExceptionLogs from "./pages/ErrorExceptionLogs";
import DataBackupRestore from "./pages/DataBackup&Restore";
import LicenseManagement from "./pages/LicenseManagement";
import ThirdPartyIntegrations from "./pages/ThirdPartyIntegrations";
import SecurityCenter from "./pages/SecurityCenter";
import RolesPermissions from "./pages/Roles&Permissions";
import OrgStructureSetup from "./pages/OrgStructureSetup";
import SecurityAccessControl from "./pages/Security&AccessControl";
import SystemPreferences from "./pages/SystemPreferences";
import APIIntegrationSettings from "./pages/APIIntegrationSettings";
import HrDashboard from "./pages/HrDashboard";
import EmployeeMaster from "./pages/EmployeeMaster";
import EmployeeDocumentsVault from "./pages/EmployeeDocumentsVault";
import LetterTemplateMgmt from "./pages/LetterTemplateMgmt";
import AssetAllocationSetup from "./pages/AssetAllocationSetup";
import HelpdeskCategorySetup from "./pages/HelpdeskCategorySetup";
import EngagementRRSetup from "./pages/EngagementRRSetup";
import SurveyBuilder from "./pages/SurveyBuilder";
import EventsAnnouncements from "./pages/EventsAnnouncements";
import AttendancePolicySetup from './pages/AttendancePolicySetup';
import ShiftRotationSetup from './pages/ShiftRotationSetup';
import HolidayWeeklyOffCalendar from './pages/HolidayWeeklyOffCalendar';
import OvertimeLateRulesSetup from './pages/OvertimeLateRulesSetup';
import LeaveAccrualRulesSetup from './pages/LeaveAccrualRulesSetup';
import AttendanceRegularization from "./pages/AttendanceRegularization";
import BiometricIntegrationSetup from "./pages/BiometricIntegrationSetup";
import RemoteWorkPolicySetup from './pages/RemoteWorkPolicySetup';
import PayrollConfiguration from "./pages/PayrollConfiguration";
import PayCycleConfiguration from "./pages/PayCycleConfiguration";
import AutoTaxForm16Setup from "./pages/AutoTaxForm16Setup";
import ReimbursementBonusRules from "./pages/ReimbursementBonusRules";
import EarningDeductionHeadSetup from "./pages/EarningDeductionHeadSetup";
import ComplianceSetup from "./pages/ComplianceSetup";
import SalaryStructureBuilder from "./pages/SalaryStructureBuilder";
import CTCTemplates from "./pages/CTCTemplates";
import PayrollRunRollback from "./pages/PayrollRunRollback";
import FullFinalSettlement from "./pages/FullFinalSettlement";
import JobPostingSetup from "./pages/JobPostingSetup";
import JdTemplates from "./pages/JdTemplates";
import HiringPipelineSetup from "./pages/HiringPipelineSetup";
import InterviewRoundsSetup from "./pages/InterviewRoundsSetup";
import InterviewFeedback from "./pages/InterviewFeedback";
import OfferLetterRules from "./pages/OfferLetterRules";
import InternalJobsSettings from "./pages/InternalJobsSettings";
import CandidateDatabaseControl from "./pages/CandidateDatabaseControl";
import KraKpiTemplates from "./pages/KRAKpiTemplates";
import PerformanceCycleSetup from "./pages/PerformanceCycleSetup";
import ScoringRules from "./pages/ScoringRules";
import AppraisalWorkflowSetup from "./pages/AppraisalWorkflowSetup";
import Promo from "./pages/Promo";
import Course from "./pages/Course";
import Assign from "./pages/Assign.jsx";
import SLAManagement from "./pages/SLAManagement";
import TicketCategories from "./pages/TicketCategories";
import TicketAssignment from "./pages/TicketAssignment";
import NotificationTemplates from "./pages/NotificationTemplates";
import MeetingSchedulingConfig from "./pages/MeetingSchedulingConfig";
import Help from "./pages/Help";
import UserHelp from "./pages/UserHelp";
import Myprofile from "./pages/Myprofile";
import Attendance from "./pages/Attendance";
import Pay from "./pages/Pay";
import TaxPage from "./pages/TaxPage";
import InsurancePage from "./pages/Insurance";
import DocumentsPage from "./pages/Documents";
import AttendancePage from "./pages/AttendancePage";
import AttendanceManagement from "./pages/AttendanceManagement";
import Boarding from "./pages/Boarding";
import Resign from "./pages/Resign";
import AttendanceCorrectionRequest from "./pages/AttendanceCorrectionRequest.jsx";
import ManagerAttendanceCorrectionApproval from "./pages/ManagerAttendanceCorrectionApproval";
import FieldWorkSafetyProtocol from "./pages/FieldWorkSafetyProtocol";
import POSHCompliancePolicy from "./pages/POSHCompliancePolicy";
import DPDPPolicy from "./pages/DPDPPolicy";
import SupportTeams from "./pages/SupportTeams.jsx";
import TicketDashboard from "./pages/TicketDashboard.jsx";
import Livetracking from "./pages/Livetracking.jsx";
import RemoteComplaince from "./pages/RemoteComplaince.jsx";
import Workforce from "./pages/Workforce.jsx";
import PayrollReports from "./pages/PayrollReports.jsx";
import FieldPerformance from "./pages/FieldPerformance.jsx";
import WorkUpdates from "./pages/WorkUpdates.jsx";
import Appreciations from "./pages/Appreciations";
import WorkStatus from "./pages/WorkStatus";
import RecognitionCenter from "./pages/RecognitionCenter";
import Policies from "./pages/Policies.jsx";
import HRISPage from "./pages/hris";
import AttendPage from "./pages/attend";
import PayrollPage from "./pages/roll";
import OKRPage from "./pages/okr";
import Performancepage from "./pages/performance.jsx";
import DocPage from "./pages/doc.jsx";
import DeskPage from "./pages/desk";
import HiringPage from "./pages/hiring.jsx";
import OfferLetter from "./pages/OfferLetter";
import AppointmentScheduling from "./pages/AppointmentScheduling";
import WarningLetter from "./pages/warning.jsx";
import IncrementLetter from "./pages/Increment.jsx";
import ExperienceLetter from "./pages/Experience.jsx"
import RelievingLetter from "./pages/Relieving.jsx"
import CustomLetter from "./pages/Custom.jsx";
import PayrollSettings from "./pages/PayrollSettings.jsx";
import TaxComputation from "./pages/TaxComputation.jsx";
import TaxProof from "./pages/TaxProof.jsx";
import CandidateLifecycle from "./pages/CandidateLifecycle.jsx";
import EmployeeMyProfile from "./pages/EmployeeMyprofile.jsx";
import EmployeeMasterAdmin from "./pages/EmployeeMasterAdmin";
import SystemConfiguration from "./pages/SystemConfiguration";
import TransportManagement from "./pages/TransportManagement.jsx";
import AssignTraining from "./pages/manager/learning/AssignTraining.jsx";
import AppraisalSetup from "./pages/manager/AppraisalSetup.jsx";
import PerformanceReviews from "./pages/manager/PerformanceReviews.jsx";

// Manager Appraisal Pages
import AssignKPIs from "./pages/manager/appraisal/AssignKPIs";
import TeamAppraisals from "./pages/manager/appraisal/TeamAppraisals";
import ReviewAppraisal from "./pages/manager/appraisal/ReviewAppraisal";

// Admin Appraisal Management
import AppraisalManagement from "./pages/admin/AppraisalManagement";

// SUPER ADMIN (Company Admin) PAGES
import AdminOverview from "./pages/AdminOverview.jsx";
import PeopleManagement from "./pages/PeopleManagement.jsx";

import EmployeeSetup from "./pages/EmployeeSetup";
import EmployeeMasterProfile from "./pages/EmployeeMasterProfile";
import CompanyProfile from "./pages/CompanyProfile";
import Administration from "./pages/Administration";
import CrmDashboard from "./pages/crm/CrmDashboard";
import CrmHelpdesk from "./pages/Helpdesk";
import LiveWorkforce from "./pages/crm/LiveWorkforce";
import AttendanceAnalytics from "./pages/crm/AttendanceAnalytics";
import SitePerformance from "./pages/crm/SitePerformance";
import ItemDelivery from "./pages/crm/ItemDelivery";
import ItemLifecycle from "./pages/crm/ItemLifecycle";
import GpsHistory from "./pages/crm/GpsHistory";
import ServiceWarrantyConfig from "./pages/crm/ServiceWarrantyConfig";
import Productivity from "./pages/crm/Productivity";
import Reports from "./pages/crm/Reports";
import Alerts from "./pages/crm/Alerts";
import PeopleOperationsDashboard from "./pages/PeopleOperationsDashboard.jsx";
import PayrollDashboard from "./pages/PayrollDashboard.jsx";
import HelpdeskDashboard from "./pages/HelpdeskDashboard";
import PolicyManagementDashboard from "./pages/PolicyManagementDashboard";
import ReportsFormenu from "./pages/ReportsFormenu.jsx";
import HiringRecruitmentDashboard from "./pages/HiringRecruitmentDashboard";
import LiveTrackingDashboard from "./pages/LiveTrackingDashboard.jsx";
import PerformanceLearningDashboard from "./pages/PerformanceLearningDashboard.jsx";


// GLOBAL ADMIN
import GlobalAdminLayout from "./pages/global-admin/GlobalAdminLayout";
import GlobalAdminDashboard from "./pages/global-admin/Dashboard";
import Companies from "./pages/global-admin/Companies";
import CreateCompany from "./pages/global-admin/CreateCompany";
import CompanyDetails from "./pages/global-admin/CompanyDetails";
import SuperAdmins from "./pages/global-admin/SuperAdmins";

function App() {
  return (
    <Routes>

      {/* Public Routes */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/set-password" element={<SetPassword />} />
      <Route path="/hris" element={<HRISPage />} />
      <Route path="/attend" element={<AttendPage />} />
      <Route path="/roll" element={<PayrollPage />} />
      <Route path="/okr" element={<OKRPage />} />
      <Route path="/performance" element={<Performancepage />} />
      <Route path="/doc" element={<DocPage />} />
      <Route path="/desk" element={<DeskPage />} />
      <Route path="/hiring" element={<HiringPage />} />

      {/* Manager standalone pages (outside layouts) */}
      <Route path="/manager/requests" element={<TeamRequests />} />
      <Route path="/manager/team-attendance" element={<TeamAttendanceReports />} />
      <Route path="/manager/assign-training" element={<AssignTraining />} />
      <Route path="/manager/assign-trainings" element={<Assign />} />
      <Route path="/manager/training-calender" element={<TrainingCalendar />} />
      <Route path="/manager/course-creation" element={<Course />} />
      <Route path="/manager/work-updates" element={<WorkUpdates />} />
      <Route path="/manager/appreciations" element={<Appreciations />} />
      <Route path="/manager/overtime-late-rules" element={<OvertimeLateRulesSetup />} />
      <Route path="/manager/live-tracking-dashboard" element={<LiveTrackingDashboard />} />
      <Route path="/manager/appraisal-setup" element={<AppraisalSetup />} />
      <Route path="/manager/performance-reviews" element={<PerformanceReviews />} />
      <Route path="/manager/appraisal/assign" element={<AssignKPIs />} />
      <Route path="/manager/appraisal/team" element={<TeamAppraisals />} />
      <Route path="/manager/appraisal/review/:empCode/:cycleId" element={<ReviewAppraisal />} />

      {/* EMPLOYEE DASHBOARD + nested routes */}
      <Route path="/dashboard/*" element={<MainLayout />}>
        <Route index element={<Dashboard />} />
        <Route path="employees" element={<Employees />} />
        <Route path="leaves" element={<Leaves />} />
        <Route path="payroll" element={<Payroll />} />
        <Route path="mischart" element={<MISDashboard />} />
        <Route path="cvbank" element={<CVBank />} />
        <Route path="settings" element={<Settings />} />
        <Route path="tax-proof" element={<TaxProof />} />
        <Route path="tax-computations" element={<TaxComputation />} />

        {/* ESS */}
        <Route path="payslip-history" element={<PayslipHistory />} />
        <Route path="my-benefits" element={<MyBenefits />} />
        <Route path="company-directory" element={<CompanyDirectory />} />
        <Route path="leave-requests" element={<LeaveRequests />} />
        <Route path="employee-documents" element={<EmployeeDocuments />} />
        <Route path="helpdesk" element={<Helpdesk />} />
        <Route path="internal-jobs" element={<InternalJobs />} />
        <Route path="engagement" element={<Engagement />} />

        <Route path="exit" element={<Exit />} />
        <Route path="org-structure" element={<OrganizationStructure />} />
        <Route path="employee-profile" element={<EmployeeProfile />} />
        <Route path="ess-portal" element={<EmployeeESS />} />

        <Route path="attendance-Management" element={<AttendanceManagement />} />
        <Route path="leave-balance" element={<LeaveBalance />} />
        <Route path="attendance-selfie" element={<AttendanceSelfie />} />
        <Route path="attendance-geofence" element={<AttendanceGeofence />} />
        <Route path="rotational-shift" element={<RotationalShift />} />
        <Route path="field-work" element={<FieldWorkReport />} />
        <Route path="live-tracking" element={<Livetracking />} />
        <Route path="location-punching" element={<ContinuousLocationPunching />} />

        <Route path="salary" element={<Salary />} />
        <Route path="bonus" element={<Bonus />} />
        <Route path="pf-esi" element={<PFESIReport />} />
        <Route path="expense-reimbursement" element={<ExpenseReimbursement />} />

        <Route path="recruitment-dashboard" element={<RecruitmentDashboard />} />
        <Route path="job-offer" element={<JobOffer />} />
        <Route path="job-offer-management" element={<JobOfferManagement />} />

        <Route path="performance-dashboard" element={<PerformanceDashboard />} />
        <Route path="performance-review" element={<PerformanceReview />} />
        <Route path="goals-tracking" element={<GoalsTracking />} />
        <Route path="feedback-360" element={<Feedback360 />} />
        <Route path="growth-report" element={<GrowthPerformanceReport />} />
        <Route path="skill-matrix" element={<SkillMatrix />} />

        <Route path="training-dashboard" element={<TrainingDashboard />} />
        <Route path="course-details" element={<CourseDetails />} />
        <Route path="training" element={<TrainingCalendar />} />
        <Route path="lms-dashboard" element={<LMSDashboard />} />

        <Route path="job-work" element={<JobWorkReport />} />
        <Route path="announcements" element={<Announcements />} />
        <Route path="userhelp" element={<UserHelp />} />

        <Route path="Myprofile" element={<Myprofile />} />
        <Route path="attendancepage" element={<AttendancePage />} />
        <Route path="pay" element={<Pay />} />
        <Route path="taxpage" element={<TaxPage />} />
        <Route path="insurance" element={<InsurancePage />} />
        <Route path="documents" element={<DocumentsPage />} />
        <Route path="Boarding" element={<Boarding />} />
        <Route path="Resign" element={<Resign />} />
        <Route path="AttendanceCorrectionRequest" element={<AttendanceCorrectionRequest />} />
        <Route path="WorkStatus" element={<WorkStatus />} />
        <Route path="RecognitionCenter" element={<RecognitionCenter />} />
        <Route path="Policies" element={<Policies />} />
        <Route path="TransportManagement" element={<TransportManagement />} />

        <Route path="analytics-dashboard" element={<AnalyticsDashboard />} />
        <Route path="reports" element={<ReportsDashboard />} />
      </Route>

      {/* EMPLOYER DASHBOARD + nested routes */}
      <Route path="/employerdashboard/*" element={<EmployerLayout />}>
        <Route index element={<EmployerDashboard />} />
        <Route path="employee-profile" element={<EmployeeProfile />} />
        <Route path="team-overview" element={<TeamOverview />} />
        <Route path="employee-management" element={<EmployeeManagement />} />
        <Route path="attendance-reports" element={<AttendanceReports />} />
        <Route path="leave-management" element={<LeaveManagement />} />
        <Route path="payroll-overview" element={<PayrollOverview />} />
        <Route path="performance-reports" element={<PerformanceReports />} />
        <Route path="goals-objectives" element={<GoalsObjectives />} />
        <Route path="announcements-notifications" element={<Announcements />} />
        <Route path="recruitment-pipeline" element={<RecruitmentPipeline />} />
        {/* <Route path="settings" element={<NewSettings />} /> */}
        <Route path="onboarding-offboarding" element={<OnboardingOffboarding />} />
        <Route path="training-development" element={<TrainingDevelopment />} />
        <Route path="internal-communications" element={<InternalCommunications />} />
        <Route path="feedback-management" element={<FeedbackManagement />} />
        <Route path="training-assignments" element={<TrainingAssignments />} />

        <Route path="finance-dashboard" element={<FinanceDashboard />} />
        <Route path="recruitment-analytics" element={<RecruitmentAnalytics />} />
        <Route path="workforce-turnover" element={<WorkforceTurnover />} />
        <Route path="compliance-audit" element={<ComplianceAudit />} />
        <Route path="asset-management" element={<AssetManagement />} />
        <Route path="skill-gap-analysis" element={<SkillGapAnalysis />} />
        <Route path="talent-management" element={<TalentManagement />} />
        <Route path="engagement-reports" element={<EngagementReports />} />
        <Route path="document-repository" element={<DocumentRepository />} />
        <Route path="userhelp" element={<UserHelp />} />
      </Route>

      {/* ADMIN DASHBOARD + nested routes */}
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<AdminDashboard />} />

        <Route path="profile" element={<AdminProfile />} />
        <Route path="candidate-test" element={<CandidateLifecycle />} />

        {/* SYSTEM MANAGEMENT */}
        <Route path="audit-logs" element={<AuditLogs />} />
        <Route path="data-backup-restore" element={<DataBackupRestore />} />
        <Route path="license-management" element={<LicenseManagement />} />
        <Route path="third-party-integrations" element={<ThirdPartyIntegrations />} />
        <Route path="system-settings" element={<SystemSettings />} />
        <Route path="system-health-monitoring" element={<SystemHealthMonitoring />} />
        <Route path="data-privacy-compliance" element={<DataPrivacyCompliance />} />
        <Route path="release-feature-logs" element={<ReleaseFeatureLogs />} />
        <Route path="error-exception-logs" element={<ErrorExceptionLogs />} />
        <Route path="webhook-tests" element={<WebhookTests />} />
        <Route path="automated-alerts-triggers" element={<AutomatedAlertsTriggers />} />
        <Route path="system-preferences" element={<SystemPreferences />} />
        <Route path="alerts-notifications" element={<AlertsNotifications />} />
        <Route path="api-integration-settings" element={<APIIntegrationSettings />} />

        {/* SECURITY */}
        <Route path="security-center" element={<SecurityCenter />} />
        <Route path="security-access" element={<SecurityAccessControl />} />
        <Route path="roles-permissions" element={<RolesPermissions />} />
        <Route path="user-management" element={<UserManagement />} />
        <Route path="access-logs" element={<AccessControlLogs />} />
        <Route path="security-settings" element={<AuthSecuritySettings />} />
        <Route path="encryption-mgmt" element={<EncryptionKeyMgmt />} />

        {/* ORGANIZATION SETUP */}
        <Route path="org-structure-setup" element={<OrgStructureSetup />} />
        <Route path="master-data" element={<MasterDataManagement />} />
        <Route path="policy-management" element={<PolicyManagement />} />
        <Route path="workflow-approval" element={<WorkflowApproval />} />
        <Route path="resource-quotas" element={<ResourceQuotas />} />

        {/* BRANDING / API / CONFIG */}
        <Route path="custom-branding" element={<CustomBranding />} />
        <Route path="api-docs" element={<APIDocumentation />} />

        {/* BILLING / SUPPORT */}
        <Route path="billing-licensing" element={<BillingLicensing />} />
        <Route path="support-panel" element={<HelpdeskSupport />} />

        {/* HR MODULES */}
        <Route path="employees" element={<Employees />} />
        <Route path="employee-profile" element={<EmployeeProfile />} />
        <Route path="company-directory" element={<CompanyDirectory />} />
        <Route path="employee-documents" element={<EmployeeDocuments />} />
        <Route path="onboarding" element={<Onboarding />} />
        <Route path="exit" element={<Exit />} />
        <Route path="org-structure" element={<OrganizationStructure />} />

        <Route path="hr-dashboard" element={<HrDashboard />} />
        <Route path="employee-master" element={<EmployeeMaster />} />
        <Route path="documents-vault" element={<EmployeeDocumentsVault />} />
        <Route path="letter-template-mgmt" element={<LetterTemplateMgmt />} />
        <Route path="asset-allocation-setup" element={<AssetAllocationSetup />} />
        <Route path="helpdesk-category-setup" element={<HelpdeskCategorySetup />} />
        <Route path="engagement-rr-setup" element={<EngagementRRSetup />} />
        <Route path="survey-builder" element={<SurveyBuilder />} />
        <Route path="events-announcements" element={<EventsAnnouncements />} />
        <Route path="attendance-policy-setup" element={<AttendancePolicySetup />} />
        <Route path="shift-rotational-setup" element={<ShiftRotationSetup />} />
        <Route path="holiday-calendar" element={<HolidayWeeklyOffCalendar />} />
        <Route path="leave-rules" element={<LeaveAccrualRulesSetup />} />
        <Route path="attendance-regularization" element={<AttendanceRegularization />} />
        <Route path="biometric-integration-setup" element={<BiometricIntegrationSetup />} />
        <Route path="remote-work-policy" element={<RemoteWorkPolicySetup />} />
        <Route path="payroll-configuration" element={<PayrollConfiguration />} />
        <Route path="pay-cycle-config" element={<PayCycleConfiguration />} />
        <Route path="tax-form16-setup" element={<AutoTaxForm16Setup />} />
        <Route path="reimbursement-bonus-rules" element={<ReimbursementBonusRules />} />
        <Route path="earning-deduction-setup" element={<EarningDeductionHeadSetup />} />
        <Route path="payroll-settings" element={<PayrollSettings />} />
        <Route path="salary-structure-builder" element={<SalaryStructureBuilder />} />
        <Route path="compliance-setup" element={<ComplianceSetup />} />
        <Route path="ctc-templates" element={<CTCTemplates />} />
        <Route path="payroll-run-rollback" element={<PayrollRunRollback />} />
        <Route path="full-final-settlement" element={<FullFinalSettlement />} />
        <Route
  path="people-operations"
  element={<PeopleOperationsDashboard />}
/>
<Route
  path="payroll-dashboard"
  element={<PayrollDashboard />}
/>
<Route path="helpdesk-support" element={<HelpdeskDashboard />} />
<Route path="policy-dashboard" element={<PolicyManagementDashboard />} />
<Route path="reports-insights" element={<ReportsFormenu />} />
<Route path="hiring-recruitment" element={<HiringRecruitmentDashboard />} />
<Route path="performance-learning" element={<PerformanceLearningDashboard />} />



        <Route path="recruitment-dashboard" element={<RecruitmentDashboard />} />
        <Route path="onboarding-automation" element={<OnboardingAutomation />} />
        <Route path="job-posting-setup" element={<JobPostingSetup />} />
        <Route path="internal-jobs" element={<InternalJobs />} />
        <Route path="engagement" element={<Engagement />} />
        <Route path="cvbank" element={<CVBank />} />
        <Route path="job-offer" element={<JobOffer />} />
        <Route path="jd-templates" element={<JdTemplates />} />
        <Route path="hiring-pipeline-setup" element={<HiringPipelineSetup />} />
        <Route path="interview-rounds-setup" element={<InterviewRoundsSetup />} />
        <Route path="interview-feedback" element={<InterviewFeedback />} />
        <Route path="offer-letter-rules" element={<OfferLetterRules />} />
        <Route path="internal-jobs-settings" element={<InternalJobsSettings />} />
        <Route path="candidate-database-control" element={<CandidateDatabaseControl />} />
        <Route path="kra-kpi-templates" element={<KraKpiTemplates />} />
        <Route path="performance-cycle-setup" element={<PerformanceCycleSetup />} />
        <Route path="scoring-rules" element={<ScoringRules />} />
        <Route path="appraisal-workflow-setup" element={<AppraisalWorkflowSetup />} />
        <Route path="promo-increment-cycle-setup" element={<Promo />} />
        <Route path="course-creation" element={<Course />} />

        <Route path="sla-management" element={<SLAManagement />} />
        <Route path="ticket-categories" element={<TicketCategories />} />
        <Route path="ticket-routing-rules" element={<TicketAssignment />} />
        <Route path="service-warranty-config" element={<ServiceWarrantyConfig />} />
        <Route path="notification-templates" element={<NotificationTemplates />} />
        <Route path="meeting-scheduling-config" element={<MeetingSchedulingConfig />} />
        <Route path="Help-desk" element={<Help />} />
        <Route path="Manager-Attendance-CorrectionApproval" element={<ManagerAttendanceCorrectionApproval />} />
        <Route path="field-work-policy-setup" element={<FieldWorkSafetyProtocol />} />
        <Route path="posh-policy-setup" element={<POSHCompliancePolicy />} />
        <Route path="dpdp-policy" element={<DPDPPolicy />} />
        <Route path="support-team-setup" element={<SupportTeams />} />
        <Route path="ticket-performance-dashboard" element={<TicketDashboard />} />
        <Route path="live-tracking-dashboard" element={<LiveTrackingDashboard />} />
        <Route path="remote-compliance-setup" element={<RemoteComplaince />} />
        <Route path="headcount-forecasting" element={<Workforce />} />
        <Route path="payroll-leave-mis" element={<PayrollReports />} />
        <Route path="field-performance-analytics" element={<FieldPerformance />} />

        <Route path="employee-Myprofile" element={<EmployeeMyProfile />} />
        <Route path="employee-master" element={<EmployeeMasterAdmin />} />
        <Route path="system-config" element={<SystemConfiguration />} />

        {/* Letter Templates */}
        <Route path="offer-letter/:catId/:templateId?" element={<OfferLetter />} />
        <Route path="appointment-letter/:catId/:templateId?" element={<AppointmentScheduling />} />
        <Route path="relieving-letter/:templateId" element={<RelievingLetter />} />
        <Route path="experience-letter/:templateId" element={<ExperienceLetter />} />
        <Route path="increment-letter/:templateId" element={<IncrementLetter />} />
        <Route path="warning-letter/:templateId" element={<WarningLetter />} />
        <Route path="Custom/:templateId" element={<CustomLetter />} />

        {/* Super Admin / Company Admin nested under /admin */}
        <Route path="admin-overview" element={<AdminOverview />} />
        <Route path="people-management" element={<PeopleManagement />} />
        <Route path="employee-setup" element={<EmployeeSetup />} />
        <Route path="employee-profile-admin" element={<EmployeeMasterProfile />} />
        <Route path="company-profile" element={<CompanyProfile />} />
        <Route path="Administration" element={<Administration />} />

        <Route path="crm" element={<CrmDashboard />} />
        <Route path="crm/helpdesk" element={<CrmHelpdesk />} />
        <Route path="crm/live-workforce" element={<LiveWorkforce />} />
        <Route path="crm/attendance-analytics" element={<AttendanceAnalytics />} />
        <Route path="crm/site-performance" element={<SitePerformance />} />
        <Route path="crm/item-delivery" element={<ItemDelivery />} />
        <Route path="crm/item-lifecycle" element={<ItemLifecycle />} />
        <Route path="crm/gps-history" element={<GpsHistory />} />
        <Route path="crm/productivity" element={<Productivity />} />
        <Route path="crm/reports" element={<Reports />} />
        <Route path="crm/alerts" element={<Alerts />} />
        <Route path="appraisal-management" element={<AppraisalManagement />} />
      </Route>

      {/* GLOBAL ADMIN – top-level routes */}
      <Route path="/global-admin" element={<GlobalAdminLayout />}>
        <Route index element={<GlobalAdminDashboard />} />
        <Route path="dashboard" element={<GlobalAdminDashboard />} />
        <Route path="companies" element={<Companies />} />
        <Route path="companies/create" element={<CreateCompany />} />
        <Route path="companies/:companySlug" element={<CompanyDetails />} />
        <Route path="super-admins" element={<SuperAdmins />} />
      </Route>

    </Routes>
  );
}

export default App;